import * as React from 'react'
import {FormControl, Theme, createStyles, withStyles, WithStyles, Input, Typography} from '@material-ui/core'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'
import autobind from 'autobind-decorator'
import {css} from '../../conf/style'

const styles = (t: Theme) => createStyles({
    root: {
        ...css.flexAlCenter,
        background: t.palette.common.white
    },
    formControl: {
        background: 'rgba(0, 0, 0, .04)'
    },
    adornment: {
        margin: `0 ${t.spacing.unit * 2}px`
    }
});

interface IProps extends WithI18n,
  WithStyles<typeof styles>{
  input: any;
  durationType: any;
  returnValue: string;
}


interface IStates {
    field: any;
    year: number;
    month: number;
}


class DurationField extends React.Component<IProps, IStates> {
  state = {
    field: this.props.input.value,
    year: this.props.input.value ? (this.props.input.value - this.props.input.value % 12) / 12 : 0,
    month: this.props.input.value ? this.props.input.value % 12 : 0,
  };

  render() {
    const {classes, durationType} = this.props
    return (
        <>
            <div className={classes.root}>
                {durationType.includes("year") &&
                    <>
                        <FormControl className={classes.formControl}>
                            <Input
                                value={this.state.year}
                                type="number"
                                onChange={this.handleYearChange}
                                onBlur={this.handleYearBlur}
                            />
                        </FormControl>
                        {this.state.year === undefined &&
                            <Typography variant="body2" className={classes.adornment}>an(s)</Typography> 
                        }
                        {this.state.year > 1 &&
                            <Typography variant="body2" className={classes.adornment}>ans</Typography> 
                        }
                        {this.state.year <= 1 &&
                            <Typography variant="body2" className={classes.adornment}>an</Typography> 
                        }
                    </>
                }
                {durationType.includes("month") &&
                    <>
                        <FormControl className={classes.formControl}>
                            <Input
                                value={this.state.month}
                                type="number"
                                onChange={this.handleMonthChange}
                                onBlur={this.handleMonthBlur}
                            />
                        </FormControl>
                        <Typography variant="body2" className={classes.adornment}>mois</Typography> 
                    </>
                }
            </div>
       
        </>
    )
  }

  @autobind
  private handleYearBlur(event: any){
    this.setState({year: this.parseField(event.target.value)})
    this.props.input.onChange(this.parseField(event.target.value) * 12 + this.state.month);
  }

  @autobind
  private handleMonthBlur(event: any){
    this.setState({month: this.parseField(event.target.value)})
    this.props.input.onChange(this.parseField(event.target.value) + this.state.year * 12);
  }

  @autobind
  private handleYearChange(event: any){
        this.setState({year: this.checkFiled(event.target.value)})
        this.props.input.onChange(this.checkFiled(event.target.value) * 12 + this.state.month);
  }

  @autobind
  private handleMonthChange(event: any){
        this.setState({month: this.checkFiled(event.target.value)})
        this.props.input.onChange(this.checkFiled(event.target.value) + this.state.year * 12);
  }

  @autobind
  private checkFiled(field: any){
      return field ? parseInt(field, 10) : field
  }

  @autobind
  private parseField(field: any){
      return field && field.length > 0 ? parseInt(field, 10) : 0
  }
}

export default compose(
  withI18n,
  withStyles(styles)
)(DurationField)



// WEBPACK FOOTER //
// ./src/shared/form/DurationField.tsx